import Cookies from "js-cookie";
import React, { SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AppointmentCard from "src/Components/Cards/AppointmentCard";
import DoctorWhislistCard from "src/Components/WebsiteComponents/HomePage/Cards/DoctorWhislistCard";
import httpRequest from "src/helpers/httpRequest";
import { customer, doctorMode } from "src/lib/constans";
import {
  IAppintentType,
  IAppointmentItems,
  IDropDownArray,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { capitalize } from "@mui/material";
import moment from "moment";
import PaginationWrapper from "src/Components/WebsiteComponents/PaginationWrapper";
import { Dispatch } from "@reduxjs/toolkit";
import NoItemUI from "src/Components/NoItemUI";
import { useNavigate } from "react-router-dom";
import { truncate } from "src/helpers/helperFunctions";

interface IItems {
  _id: string;
  serviceName: string;
  totalAmount: number;
  appointmentDate: string;
  status: "pending" | "cancelled" | "completed";
  serialOrderId: string;
  timeslot: string;
  createdAt: string;
  [key: string]: any;
}

interface IResponse {
  documents: IItems[];
  paginated: IPaginated;
}

interface IProps {
  setData: any;
  data: IAppintentType[];
  setIsLoader: any;
  queryParams: IqueryParams;
  setPaginated: any;
  isLoader: boolean;
  onClose: () => void;
}

const AtHomeAppointmentSection: React.FC<IProps> = ({
  setData,
  data,
  setIsLoader,
  queryParams,
  setPaginated,
  isLoader,
  onClose,
}) => {
  const navigate = useNavigate();
  const fetch = async () => {
    setIsLoader(true);
    let q = {
      ...queryParams,
      isOnline: false,
    };
    const { res, err } = await httpRequest<IResponse>({
      path: `/home-care-order/user-orders?${qs.stringify(queryParams)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      let data = documents.map((item: any) => {
        let dat: IAppintentType = {
          id: item?._id,
          status: item?.status,
          rating: 4,
          fee: Number(item?.totalAmount),
          date: moment(item?.appointmentDate).format("DD-MM-YYYY"),
          time: item?.timeslot,
          image: item?.serviceImage,
          serviceCategory:
            truncate(item?.categoryName.join(", ") || "", 30) || "",
          serviceName: item?.serviceName || "",
          customerNotified: item?.customerNotified,
        };
        return dat;
      });
      setData((prev: IAppintentType[]) => [...prev, ...data]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" }); // Show error toast if API call fails
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [queryParams]);

  return (
    <>
      {data.map((doctor, index) => (
        <AppointmentCard
          id={`view-details-${index}`}
          key={doctor.id}
          doctor={doctor}
          type="at-home"
          onViewDetails={() => {
            onClose();
            navigate(`/customer/homecare-appointment/${doctor.id}/view`);
          }}
          unread={doctor?.customerNotified ? 0 : 1}
        />
      ))}
    </>
  );
};

export default AtHomeAppointmentSection;
